import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { colors } from '../../constants.js/colors';
import ButtonUpgradePlan from '../ButtonUpgradePlan';
import BlackFilledCrown from '../../assets/icons/freemium-plan/black-filled-crown.svg';

const AlertFreemiumPlan = ({ alertMessage = '' }) => {
    const message =
        alertMessage !== ''
            ? alertMessage
            : 'Estás usando el plan gratuito. Puedes subir hasta 20 productos y 1 línea de WhatsApp. Para más funciones, actualiza a profesional. 👑';

    return (
        <Alert
            icon={
                <span>
                    <img src={BlackFilledCrown} alt="icon" />
                </span>
            }
            severity="warning"
            style={{
                backgroundColor: colors.white,
                border: `1px solid ${colors.gold.primary}`,
            }}
        >
            <AlertTitle>
                {message}
                <br />
            </AlertTitle>
            <ButtonUpgradePlan />
        </Alert>
    );
};

export default AlertFreemiumPlan;
